import {
  AlertTriangle,
  FileText,
  GitCompare,
  Infinity,
  ListChecks,
  Sparkles,
  WandSparkles,
} from "lucide-react";
import { Mode } from "../taskpane/types/Mode";

export const CHAT_MODES: Mode[] = [
  {
    id: "agent",
    label: "Agent",
    description:
      "Répond à vos questions et exécute vos demandes de modification de manière autonome.",
    icon: Infinity,
  },
  {
    id: "find-errors",
    label: "Détection d'erreurs",
    description: "Analyse le texte pour détecter fautes, incohérences et problèmes de forme.",
    icon: WandSparkles,
  },
  {
    id: "list-clauses",
    label: "Extraction de clauses",
    description: "Extrait et structure les clauses d'un texte contractuel ou juridique.",
    icon: ListChecks,
  },
  {
    id: "analyze-risks",
    label: "Analyse des risques",
    description: "Identifie les risques juridiques ou contractuels présents dans le texte.",
    icon: AlertTriangle,
  },
  {
    id: "improve-selection",
    label: "Amélioration de texte",
    description: "Réécrit le texte pour le rendre plus clair, précis et professionnel.",
    icon: Sparkles,
  },
  {
    id: "compare-documents",
    label: "Comparaison de documents",
    description:
      "Compare deux versions d'un même document pour identifier les différences et modifications.",
    icon: GitCompare,
  },
  {
    id: "fill-template",
    label: "Remplissage de modèle",
    description: "Remplit un modèle de document avec les données fournies.",
    icon: FileText,
  },
];
